import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Page404 from 'pages/Page404';
import UsersList from 'components/users/UsersList';
import { useHasPermission } from 'services/login/hooks';
import { getPaneContent, setPaneContent } from 'services/pane/slice';
import { useGetUsersQuery } from 'services/users/api';
import links from 'utils/links';
import { PERMISSIONS } from 'utils/permissions';
import { spaLinkProps } from 'utils/spaLink';

const UsersPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const paneContent = useSelector(getPaneContent);
  const selectedUserId = paneContent?.type === 'USER' ? paneContent.id : undefined;
  const canListUsers = useHasPermission(PERMISSIONS.USERS_LIST);
  const { data: users } = useGetUsersQuery(undefined, {
    skip: !canListUsers,
  });

  useEffect(() => {
    if (!canListUsers) {
      return;
    }
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, [canListUsers, location.pathname]);

  if (!canListUsers) {
    return <Page404 />;
  }

  return (
    <>
      <Helmet>
        <title>{`${t('users')} · ${t('admin')}`}</title>
      </Helmet>
      <Breadcrumb
        items={[
          { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
          { ...spaLinkProps(links.paths.admin, navigate), label: t('admin') },
          { label: t('users') },
        ]}
      />
      <h4>{t('users')}</h4>
      <UsersList
        onUserClick={
          userId => dispatch(
            setPaneContent({
              type: 'USER',
              id: userId,
            }),
          )
        }
        selectedUserId={selectedUserId}
        users={users}
      />
    </>
  );
};

export default UsersPage;
